import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Button from '@saucelabs/sl-component-buttons';
import { SLDropdown, SLToggle, SLMenu } from '@saucelabs/sl-component-dropdown';
import MenuItem from '@saucelabs/sl-component-menu-item';
import { Modal } from '@saucelabs/sl-component-overlay';
import modalConnect from '@saucelabs/sl-container-modal';

import Styles from './../../components/AssignmentModal.styles';

const name = 'assignTeamsToGroup';

class AssignTeamsToGroupModal extends Component {
  state = { chosenGroupId: null };

  shouldComponentUpdate(nextProps) {
    const { show } = this.props;
    return show !== nextProps.show || nextProps.show;
  }

  onGroupSelect = (id) => {
    this.setState({ chosenGroupId: id });
  }

  cleanAndHide = () => {
    const { onHide } = this.props;

    this.cleanup();
    onHide();
  }

  submit(payload) {
    const { handleSubmit } = this.props;
    handleSubmit(payload).then(() => this.cleanAndHide());
  }

  cleanup() {
    this.setState({ chosenGroupId: null });
  }

  renderNoGroupsNotification() {
    const { onHide, show } = this.props;
    return (
      <Modal
        onHide={onHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Group Assignment</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={Styles['body-spacing']}
        >
          <p>
            <b>You need to create at last one group to proceed</b>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="action"
            material
            onClick={onHide}
            size="sm"
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { groups, onTeamClick, selectedTeams, show, teams } = this.props;
    const { chosenGroupId } = this.state;
    const chosenGroup = groups.find(({ id }) => id === chosenGroupId) || groups.first();

    if (!chosenGroup) {
      return this.renderNoGroupsNotification();
    }

    return (
      <Modal
        onHide={this.cleanAndHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Group Assignment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="label">
            {'Assign the following '}
            {selectedTeams.size}
            {' '}
            {selectedTeams.size === 1 ? 'team' : 'teams'}
          </h5>
          <div>
            {selectedTeams.map((teamId) => {
              const team = teams.get(teamId);
              return (
                <span
                  key={team.name}
                  className={Styles['item-chip']}
                  onClick={() => onTeamClick(team.id)}
                  role="presentation"
                >
                  <span>x</span>
                  {' '}
                  {team.name}
                </span>
              );
            })}
          </div>
          <br />
          <span className="label">
            {'To group: '}
            <span className={Styles['optional-label']}>(optional)</span>
          </span>
          <br />
          <SLDropdown
            className={Styles.dropdown}
            id="groups-dropdown"
          >
            <SLToggle
              bsRole="toggle"
              isInputForm
            >
              {chosenGroup.name}
            </SLToggle>
            <SLMenu
              bsRole="menu"
              onSelect={this.onGroupSelect}
            >
              {groups.valueSeq().map((group) => (
                <MenuItem
                  key={group.name}
                  eventKey={group.id}
                >
                  {group.name}
                </MenuItem>
              ))}
            </SLMenu>
          </SLDropdown>
          <div className={Styles['info-block']}>
            <p>
              New group assignments will replace current assignments!
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="default"
            material
            onClick={this.cleanAndHide}
            size="sm"
          >
            Cancel
          </Button>
          <Button
            category="action"
            material
            name="assign"
            onClick={() => this.submit({
              groupId: chosenGroup.id,
              selectedTeams,
            })}
            size="sm"
          >
            Assign
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

AssignTeamsToGroupModal.propTypes = {
  groups: ImmutablePropTypes.orderedMap.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  onTeamClick: PropTypes.func.isRequired,
  selectedTeams: ImmutablePropTypes.list.isRequired,
  show: PropTypes.bool.isRequired,
  teams: ImmutablePropTypes.orderedMap.isRequired,
};

export default modalConnect(name, AssignTeamsToGroupModal);
export { name, AssignTeamsToGroupModal };
